import React, { Fragment, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import * as Entities from "entities";

import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";
// import ExpansionPanel from "@material-ui/core/ExpansionPanel";
// import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
// import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import IconButton from "@material-ui/core/IconButton";
import Link from "@material-ui/core/Link";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import MoreVertIcon from "@material-ui/icons/MoreVert";

import { LOCATION_CHANGE_STATUS_URL } from "../../config";
import AddEditLocForm from "./AddEditLocForm";
import CategoriesForm from "./CategoriesForm";
import AdmAreaForm from "./AdmAreaForm";
import StatusForm from "./StatusForm";
import DeleteLocForm from "./DeleteLocForm";
import ConfirmDialog from "../dialog/ConfirmDialog";
import KeyValue from "../display/KeyValue";
import StatusChip from "./StatusChip";
import AdmAreaBreadcrumbs from "./AdmAreaBreadcrumbs";
import { showSuccessAlert, showErrorAlert } from "../../store/actions/alerts";
import { fromUnixtime } from "../../utils/time";
import UserChip from "../user/UserChip";
import { locationUrl } from "../../utils/url";

import makeApiRequest from "../../utils/axios/new-axios";
import { permissions, types, checkAcl } from "../../utils/acl";

const useStyles = makeStyles((theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  paper: {
    width: "100%",
    overflowX: "auto",
    marginBottom: theme.spacing(2),
    backgroundColor: "#212121",
    padding: "15px",
  },
  chip: {
    margin: theme.spacing(1),
    marginLeft: "0px",
  },
  menu: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(2),
  },
  paperTable: {
    width: "100%",
    overflowX: "auto",
    marginBottom: theme.spacing(2),
  },
}));

const ITEM_HEIGHT = 48;

export default function LocationDetails({ locationDetails, setMapCoords }) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const EDIT_ACCESS = checkAcl({ p: permissions.LOCATION_MANAGEMENT, t: types.VIEW_AND_EDIT });
  const DELETE_ACCESS = checkAcl({ p: permissions.LOCATION_MANAGEMENT, t: types.VIEW_EDIT_AND_DELETE });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openCategoryModal, setOpenCategoryModal] = useState(false);
  const [openAdmModal, setOpenAdmModal] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [openPublishModal, setOpenPublishModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [admDetails, setAdmDetails] = useState(null);
  const [locStatus, setLocStatus] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);
  const [values, setValues] = useState();

  // verical menu
  function handleMenuClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleMenuClose() {
    setAnchorEl(null);
  }

  // Edit Details
  function menuEditDetailsClick() {
    handleMenuClose();
    handleOpenEditModal();
  }

  function handleOpenEditModal() {
    setOpenEditModal(true);
  }

  function handleCloseEditModal() {
    setOpenEditModal(false);
  }

  // Edit Category
  function menuEditCategoryClick() {
    handleMenuClose();
    handleOpenCategoryModal();
  }
  function handleOpenCategoryModal() {
    setOpenCategoryModal(true);
  }

  function handleCloseCategoryModal() {
    setOpenCategoryModal(false);
  }

  // Change Administrative Area
  function menuEditAdmClick() {
    handleMenuClose();
    handleOpenAdmModal();
  }
  function handleOpenAdmModal() {
    setOpenAdmModal(true);
  }

  function handleCloseAdmModal() {
    setOpenAdmModal(false);
  }

  // Change Status
  function menuChangeStatusClick() {
    handleMenuClose();
    handleOpenStatusModal();
  }
  function handleOpenStatusModal() {
    setOpenStatusModal(true);
  }

  function handleCloseStatusModal() {
    setOpenStatusModal(false);
  }

  // Publish/Un-publish
  function menuPublishClick() {
    handleMenuClose();
    handleOpenPublishModal();
  }
  function handleOpenPublishModal() {
    setOpenPublishModal(true);
  }

  function handleClosePublishModal() {
    setOpenPublishModal(false);
  }

  async function publishLocationCall(id) {
    setIsSubmitting(true);

    const reqJson = {
      status: locStatus.status === 1 ? 0 : 1,
    };

    await makeApiRequest({
      url: `${LOCATION_CHANGE_STATUS_URL.url}/${id}`,
      method: LOCATION_CHANGE_STATUS_URL.method,
      data: reqJson,
    })
      .then((response) => {
        dispatch(
          showSuccessAlert(
            `${reqJson.status === 1 ? "Published" : "Un-Published"
            } Successfully!`
          )
        );
        setLocStatus(reqJson);
        handleClosePublishModal();
      })
      .catch((error) => {
        dispatch(
          showErrorAlert(
            "Error : " +
            (!!error.response
              ? `${error.response.status}! - ${error.response.data.errorMessage}`
              : error.message)
          )
        );
      });

    setIsSubmitting(false);
  }

  // delete location
  function menuDeleteClick() {
    handleMenuClose();
    handleOpenDeleteModal();
  }

  function handleOpenDeleteModal() {
    setOpenDeleteModal(true);
  }

  function handleCloseDeleteModal() {
    setOpenDeleteModal(false);
  }

  useEffect(() => {
    setValues({
      name: !!locationDetails.name ? locationDetails.name : "",
      lat: !!locationDetails.coordinates ? locationDetails.coordinates.lat : "",
      lng: !!locationDetails.coordinates ? locationDetails.coordinates.lng : "",
      caption: !!locationDetails.caption ? locationDetails.caption : "",
      description: !!locationDetails.description ? locationDetails.description : "",
      thingsToDo: !!locationDetails.thingsToDo ? locationDetails.thingsToDo : "",
      history: !!locationDetails.history ? locationDetails.history : "",
      bestTimeToVisit: !!locationDetails.bestTimeToVisit ? locationDetails.bestTimeToVisit : "",
      tips: !!locationDetails.tips ? locationDetails.tips : "",
      facts: !!locationDetails.facts ? locationDetails.facts : "",
      timeSpend: !!locationDetails.timeSpend ? locationDetails.timeSpend : "",
      howToReach: !!locationDetails.howToReach ? locationDetails.howToReach : "",
      fee: !!locationDetails.fee ? locationDetails.fee : "",
      openingHours: !!locationDetails.openingHours ? locationDetails.openingHours : "",
      postalCode: !!locationDetails.postalCode
        ? locationDetails.postalCode
        : "",
      address: !!locationDetails.address ? locationDetails.address : "",
      link: !!locationDetails.link ? locationDetails.link : "",
      meta: {
        title: locationDetails?.meta?.title ?? "",
        description: locationDetails?.meta?.description ?? "",
      },
      googlePlaceId: !!locationDetails.googlePlaceId
        ? locationDetails.googlePlaceId
        : "",
    });
    locationDetails.category && setSelectedCategory(locationDetails.category);
    setAdmDetails({
      adm: locationDetails.adm,
      countryCode: locationDetails.countryCode,
    });
    setLocStatus({
      status: locationDetails.status,
    });
  }, [locationDetails]); //run only when locationDetails changes

  return (
    <Fragment>
      <Accordion expanded>
        <AccordionSummary
          aria-controls="loc-detail-content"
          id="loc-detail-header"
        >
          <Typography className={classes.heading}>Details</Typography>
          {EDIT_ACCESS &&
            <Fragment>
              <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleMenuClick}
                className={classes.menu}
              >
                <MoreVertIcon />
              </IconButton>

              <Menu
                id="long-menu"
                anchorEl={anchorEl}
                keepMounted
                open={menuOpen}
                onClose={handleMenuClose}
                PaperProps={{
                  style: {
                    maxHeight: ITEM_HEIGHT * 9,
                    width: 200,
                  },
                }}
              >
                <MenuItem key="edit-detail" onClick={menuEditDetailsClick}>
                  Edit Details
                </MenuItem>
                <MenuItem key="edit-category" onClick={menuEditCategoryClick}>
                  Edit Category
                </MenuItem>
                <MenuItem key="edit-adm" onClick={menuEditAdmClick}>
                  Edit Administrative Area
                </MenuItem>
                {locStatus && (
                  <MenuItem key="publish" onClick={menuPublishClick}>
                    {locStatus.status === 1 ? "Un-Publish" : "Publish"}
                  </MenuItem>
                )}
                {locStatus && locStatus.status !== 1 && (
                  <div>
                    <MenuItem key="change-status" onClick={menuChangeStatusClick}>
                      Change Status
                    </MenuItem>
                    {DELETE_ACCESS &&
                      <MenuItem key="delete" onClick={menuDeleteClick}>
                        Delete
                      </MenuItem>}
                  </div>
                )}
              </Menu>
            </Fragment>}
        </AccordionSummary>
        <AccordionDetails>
          <Box component="span" display="block" width="100%">
            {!!values && !!values.name ? (
              <Paper className={classes.paper}>
                <Box>
                  <Link
                    color="inherit"
                    href={locationUrl(locationDetails.id, values.name, true)}
                    underline="none"
                    target="_blank"
                    variant="subtitle1"
                    gutterBottom
                  >
                    {values.name}
                  </Link>
                </Box>
                {!!admDetails && !!admDetails.adm && (
                  <AdmAreaBreadcrumbs
                    admDetails={admDetails.adm}
                    color="textPrimary"
                  />
                )}
                <StatusChip status={locStatus.status} />
                <KeyValue keyName="ID" value={locationDetails.id} />
                <KeyValue keyName="Short Description" value={values.caption} />
                <KeyValue keyName="Address" value={values.address} />
                <KeyValue
                  keyName="Country Code"
                  value={admDetails.countryCode}
                />
                <KeyValue keyName="Postal Code" value={values.postalCode} />
                <KeyValue
                  keyName="Coordinates"
                  value={`${values.lat}, ${values.lng}`}
                />
                <KeyValue
                  keyName="External Link"
                  link={values.link}
                  value={values.link}
                  external
                />
                <KeyValue
                  keyName="Google Place ID"
                  value={values.googlePlaceId}
                />
                <KeyValue
                  keyName="Meta Title"
                  value={values?.meta?.title}
                />
                <KeyValue
                  keyName="Meta Description"
                  value={values?.meta?.description}
                />
                {!!locationDetails.createdBy && (
                  <KeyValue
                    keyName="Created By"
                    value={<UserChip user={locationDetails.createdBy} />}
                  />
                )}
                <KeyValue
                  keyName="Created On"
                  value={fromUnixtime(locationDetails.createdOn)}
                />
                <KeyValue
                  keyName="Categories"
                  value={
                    <Fragment>
                      {selectedCategory.map((cat) => {
                        return (
                          <Chip
                            size="small"
                            variant="outlined"
                            label={`${cat.categoryName} : ${cat.subCategoryName}`}
                            className={classes.chip}
                            key={cat.subCategoryId}
                            style={{
                              backgroundColor: cat.categoryColor || "#616161",
                            }}
                          />
                        );
                      })}
                    </Fragment>
                  }
                />
                {locationDetails.allCoordinates &&
                  locationDetails.allCoordinates.length > 1 && (
                    <KeyValue
                      keyName="All Coordinates"
                      value={
                        <Paper className={classes.paperTable}>
                          <Table size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell>Google Place ID</TableCell>
                                <TableCell>Coordinates</TableCell>
                                <TableCell>Is Default</TableCell>
                                <TableCell>Comment</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {locationDetails.allCoordinates.map((coord) => {
                                return (
                                  <TableRow key={coord.coordinatesId}>
                                    <TableCell>{coord.googlePlaceId}</TableCell>
                                    <TableCell>{`${coord.lat}, ${coord.lng}`}</TableCell>
                                    <TableCell>
                                      {coord.default === 1 && (
                                        <Chip
                                          size="small"
                                          label={"Default"}
                                          style={{ backgroundColor: "green" }}
                                        />
                                      )}
                                    </TableCell>
                                    <TableCell>{coord.typeText}</TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </Paper>
                      }
                    />
                  )}

                {!!values.description && (
                  <KeyValue
                    keyName="Description"
                    value={
                      <div
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          padding: "20px",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: Entities.decodeHTML5(
                            values.description.replace("&NewLine;", "")
                          ),
                        }}
                      ></div>
                    }
                  />
                )}
                {!!values.thingsToDo && (
                  <KeyValue
                    keyName="Things to Do"
                    value={
                      <div
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          padding: "20px",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: Entities.decodeHTML5(
                            values.thingsToDo.replace("&NewLine;", "")
                          ),
                        }}
                      ></div>
                    }
                  />
                )}
                {!!values.history && (
                  <KeyValue
                    keyName="History"
                    value={
                      <div
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          padding: "20px",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: Entities.decodeHTML5(
                            values.history.replace("&NewLine;", "")
                          ),
                        }}
                      ></div>
                    }
                  />
                )}
                {!!values.bestTimeToVisit && (
                  <KeyValue
                    keyName="Best time to visit"
                    value={
                      <div
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          padding: "20px",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: Entities.decodeHTML5(
                            values.bestTimeToVisit.replace("&NewLine;", "")
                          ),
                        }}
                      ></div>
                    }
                  />
                )}
                {!!values.tips && (
                  <KeyValue
                    keyName="Tips for visiting"
                    value={
                      <div
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          padding: "20px",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: Entities.decodeHTML5(
                            values.tips.replace("&NewLine;", "")
                          ),
                        }}
                      ></div>
                    }
                  />
                )}
                {!!values.facts && (
                  <KeyValue
                    keyName="Interesting Facts"
                    value={
                      <div
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          padding: "20px",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: Entities.decodeHTML5(
                            values.facts.replace("&NewLine;", "")
                          ),
                        }}
                      ></div>
                    }
                  />
                )}
                {!!values.timeSpend && (
                  <KeyValue
                    keyName="Time spent"
                    value={
                      <div
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          padding: "20px",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: Entities.decodeHTML5(
                            values.timeSpend.replace("&NewLine;", "")
                          ),
                        }}
                      ></div>
                    }
                  />
                )}
                {!!values.howToReach && (
                  <KeyValue
                    keyName="How to reach"
                    value={
                      <div
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          padding: "20px",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: Entities.decodeHTML5(
                            values.howToReach.replace("&NewLine;", "")
                          ),
                        }}
                      ></div>
                    }
                  />
                )}
                {!!values.fee && (
                  <KeyValue
                    keyName="Fee"
                    value={
                      <div
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          padding: "20px",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: Entities.decodeHTML5(
                            values.fee.replace("&NewLine;", "")
                          ),
                        }}
                      ></div>
                    }
                  />
                )}
                {!!values.openingHours && (
                  <KeyValue
                    keyName="Opening hours"
                    value={
                      <div
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          padding: "20px",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: Entities.decodeHTML5(
                            values.openingHours.replace("&NewLine;", "")
                          ),
                        }}
                      ></div>
                    }
                  />
                )}

              </Paper>
            ) : null}
          </Box>
        </AccordionDetails>
      </Accordion>
      {!!locationDetails && !!locationDetails.name && (
        <Fragment>
          <AddEditLocForm
            action="edit"
            openModal={openEditModal}
            handleCloseModal={handleCloseEditModal}
            initialValues={values}
            locationId={locationDetails.id}
            setValues={setValues}
            setMapCoords={setMapCoords}
          />
          <CategoriesForm
            openModal={openCategoryModal}
            handleCloseModal={handleCloseCategoryModal}
            initialValues={{
              category: selectedCategory.map((cat) => {
                return cat.subCategoryId;
              }),
            }}
            setSelectedCategory={setSelectedCategory}
            locationId={locationDetails.id}
            category={locationDetails.category.map((cat) => {
              return {
                categoryColor: cat.categoryColor,
                categoryId: cat.categoryId,
                categoryName: cat.categoryName,
                subCategoryId: cat.subCategoryId,
                subCategoryName: cat.subCategoryName,
              };
            })}
          />
          <AdmAreaForm
            openModal={openAdmModal}
            handleCloseModal={handleCloseAdmModal}
            locationId={locationDetails.id}
            setAdmDetails={setAdmDetails}
          />
          <StatusForm
            openModal={openStatusModal}
            handleCloseModal={handleCloseStatusModal}
            locationId={locationDetails.id}
            initialValues={locStatus}
            setLocStatus={setLocStatus}
          />
          {locStatus && (
            <ConfirmDialog
              openDialog={openPublishModal}
              handleCloseDialog={handleClosePublishModal}
              title={`${locStatus.status === 1 ? "Un-Publish" : "Publish"
                } Location`}
              message={`Are you sure you want to proceed?`}
              buttonLabel={`${locStatus.status === 1 ? "Un-Publish" : "Publish"
                }`}
              isSubmitting={isSubmitting}
              selectedIndex={locationDetails.id}
              handleSubmit={publishLocationCall}
            />
          )}

          <DeleteLocForm
            openModal={openDeleteModal}
            handleCloseModal={handleCloseDeleteModal}
            locationId={locationDetails.id}
            locationName={locationDetails.name}
          />
        </Fragment>
      )}
    </Fragment>
  );
}
